import { useMemo } from 'react';
import {
  ShippingDetailsSectionState,
  ShippingDetailsSectionStateType
} from './ShippingDetailsSection';
import { User } from 'types/User';
import { useGetUserProfile } from 'api/services/UserServiceTS';

export const useShippingDetailsState = (hasCustomShippingDetails: boolean) => {
  const [userProfileGetResult] = useGetUserProfile();

  return useMemo<ShippingDetailsSectionState>(() => {
    if (userProfileGetResult.loading) {
      return { type: ShippingDetailsSectionStateType.LOADING };
    } else if (userProfileGetResult.data) {
      const dataIsComplete = areShippingDetailsFromProfileComplete(
        userProfileGetResult.data
      );

      if (dataIsComplete) {
        if (hasCustomShippingDetails) {
          return { type: ShippingDetailsSectionStateType.CUSTOM };
        } else {
          return {
            type: ShippingDetailsSectionStateType.FROM_PROFILE,
            userProfile: userProfileGetResult.data
          };
        }
      }
    }
    return { type: ShippingDetailsSectionStateType.PROFILE_INCOMPLETE };
  }, [
    hasCustomShippingDetails,
    userProfileGetResult.data,
    userProfileGetResult.loading
  ]);
};

const areShippingDetailsFromProfileComplete = (user: User) =>
  user.shipping_address &&
  user.shipping_address.person_of_contact.trim() &&
  user.phone_number.trim() &&
  user.email.trim() &&
  user.shipping_address.company.trim() &&
  user.shipping_address.street.trim() &&
  user.shipping_address.postal_code.trim() &&
  user.shipping_address.city.trim() &&
  user.shipping_address.country.trim() &&
  user.shipping_address.country_code.trim();
